const components = {
  // Name of the component
  MuiButtonBase: {
    defaultProps: {
      // The props to change the default for.
      disableRipple: true, // No more ripple, on the whole application 💣!
    },
  },
  MuiBackdrop: {
    styleOverrides: {
      // Name of the slot
      root: {
        backgroundColor: "rgba(0, 0, 0, 0.6)",
      },
    },
  },
  MuiChip: {
    styleOverrides: {
      label: {
        fontSize: 14,
        "@media (max-width: 900px),(max-height:600px)": {
          fontSize: 12,
        },
      },
    },
  },
}

export { components }
